export const aciPackagingUnitsRaw = [
  {
    code: 'PLL',
    name: 'Air Pallet'
  },
  {
    code: 'AMM',
    name: 'Ammo Pack'
  },
  {
    code: 'BAG',
    name: 'Bag'
  },
  {
    code: 'BAL',
    name: 'Bale'
  },
  {
    code: 'BDG',
    name: 'Banding'
  },
  {
    code: 'BRG',
    name: 'Barge'
  },
  {
    code: 'BBL',
    name: 'Barrel'
  },
  {
    code: 'BSK',
    name: 'Basket or hamper'
  },
  {
    code: 'BEM',
    name: 'Beam'
  },
  {
    code: 'BLT',
    name: 'Belting'
  },
  {
    code: 'BIN',
    name: 'Bin'
  },
  {
    code: 'BIC',
    name: 'Bing Chest'
  },
  {
    code: 'BOB',
    name: 'Bobbin'
  },
  {
    code: 'BOT',
    name: 'Bottle'
  },
  {
    code: 'BOX',
    name: 'Box'
  },
  {
    code: 'BXI',
    name: 'Box, with inner container'
  },
  {
    code: 'BRC',
    name: 'Bracing'
  },
  {
    code: 'BXT',
    name: 'Bucket'
  },
  {
    code: 'BKG',
    name: 'Bulk Bag'
  },
  {
    code: 'BDL',
    name: 'Bundle'
  },
  {
    code: 'CAB',
    name: 'Cabinet'
  },
  {
    code: 'CAG',
    name: 'Cage'
  },
  {
    code: 'CAN',
    name: 'Can'
  },
  {
    code: 'CCS',
    name: 'Can Case'
  },
  {
    code: 'CBY',
    name: 'Carboy'
  },
  {
    code: 'CLD',
    name: 'Car Load, Rail'
  },
  {
    code: 'CAR',
    name: 'Carrier'
  },
  {
    code: 'CTN',
    name: 'Carton'
  },
  {
    code: 'CAS',
    name: 'Case'
  },
  {
    code: 'CSK',
    name: 'Cask'
  },
  {
    code: 'CHE',
    name: 'Cheeses'
  },
  {
    code: 'CHS',
    name: 'Chest'
  },
  {
    code: 'COL',
    name: 'Coil'
  },
  {
    code: 'CON',
    name: 'Cones'
  },
  {
    code: 'CNX',
    name: 'Connex'
  },
  {
    code: 'CNT',
    name: 'Container'
  },
  {
    code: 'CND',
    name: 'Container, Engine'
  },
  {
    code: 'CNA',
    name: 'Container, Household Goods, Wood'
  },
  {
    code: 'CNB',
    name: 'Container, Military Airlift'
  },
  {
    code: 'CNF',
    name: 'Container, Multiwall on Warehouse Pallet'
  },
  {
    code: 'CNC',
    name: 'Container, Navy Cargo'
  },
  {
    code: 'CBC',
    name: 'Containers of Bulk Cargo'
  },
  {
    code: 'COR',
    name: 'Core'
  },
  {
    code: 'CRF',
    name: 'Corner Reinforcement'
  },
  {
    code: 'CRD',
    name: 'Cradle'
  },
  {
    code: 'CRT',
    name: 'Crate'
  },
  {
    code: 'CUB',
    name: 'Cube'
  },
  {
    code: 'CYL',
    name: 'Cylinder'
  },
  {
    code: 'DRK',
    name: 'Double-length Rack'
  },
  {
    code: 'DSK',
    name: 'Double-length Skid'
  },
  {
    code: 'DTB',
    name: 'Double-length Tote Bin'
  },
  {
    code: 'DRM',
    name: 'Drum'
  },
  {
    code: 'DBK',
    name: 'Dry Bulk'
  },
  {
    code: 'DUF',
    name: 'Duffle Bag'
  },
  {
    code: 'EPR',
    name: 'Edge Protection'
  },
  {
    code: 'EGG',
    name: 'Egg Crating'
  },
  {
    code: 'ENV',
    name: 'Envelopes'
  },
  {
    code: 'FIR',
    name: 'Firkin'
  },
  {
    code: 'FSK',
    name: 'Flask'
  },
  {
    code: 'FLO',
    name: 'Flo-Bin'
  },
  {
    code: 'FWR',
    name: 'Forward Reel'
  },
  {
    code: 'FRM',
    name: 'Frame'
  },
  {
    code: 'GOH',
    name: 'Garments on Hangers'
  },
  {
    code: 'HRK',
    name: 'Half-Standard Rack'
  },
  {
    code: 'HTB',
    name: 'Half-Standard Tote Bin'
  },
  {
    code: 'HPR',
    name: 'Hamper'
  },
  {
    code: 'HED',
    name: 'Heads of Beef'
  },
  {
    code: 'HGH',
    name: 'Hogshead'
  },
  {
    code: 'HPT',
    name: 'Hopper Truck'
  },
  {
    code: 'TLD',
    name: 'Intermodal Trailer/Container Load (Rail)'
  },
  {
    code: 'JAR',
    name: 'Jar'
  },
  {
    code: 'JUG',
    name: 'Jug'
  },
  {
    code: 'KEG',
    name: 'Keg'
  },
  {
    code: 'KIT',
    name: 'Kit'
  },
  {
    code: 'KRK',
    name: 'Knockdown Rack'
  },
  {
    code: 'KTB',
    name: 'Knockdown Tote Bin'
  },
  {
    code: 'LIF',
    name: 'Lifts'
  },
  {
    code: 'LVN',
    name: 'Lift Van'
  },
  {
    code: 'SBC',
    name: 'Liner Bag Dry'
  },
  {
    code: 'FLX',
    name: 'Liner Bag Liquid'
  },
  {
    code: 'LNR',
    name: 'Liners'
  },
  {
    code: 'LID',
    name: 'Lip/Top'
  },
  {
    code: 'LBK',
    name: 'Liquid Bulk'
  },
  {
    code: 'LOG',
    name: 'Log'
  },
  {
    code: 'LSE',
    name: 'Loose'
  },
  {
    code: 'LUG',
    name: 'Lug'
  },
  {
    code: 'MSV',
    name: 'Military Sealift Command Van'
  },
  {
    code: 'MLV',
    name: 'Military Van'
  },
  {
    code: 'MIX',
    name: 'Mixed Container Types'
  },
  {
    code: 'MXD',
    name: 'Mixed Type Pack'
  },
  {
    code: 'MRP',
    name: 'Multi-Roll Pack'
  },
  {
    code: 'NOL',
    name: 'Noil'
  },
  {
    code: 'HRB',
    name: 'On Hanger or Rack in Boxes'
  },
  {
    code: 'WHE',
    name: 'On Own Wheel'
  },
  {
    code: 'OVW',
    name: 'Overwrap'
  },
  {
    code: 'PKG',
    name: 'Package'
  },
  {
    code: 'PCK',
    name: 'Packed - not otherwise specified'
  },
  {
    code: 'PAL',
    name: 'Pail'
  },
  {
    code: 'PLT',
    name: 'Pallet'
  },
  {
    code: 'PAT',
    name: 'Pallet - 2 Way'
  },
  {
    code: 'PAF',
    name: 'Pallet - 4 Way'
  },
  {
    code: 'PRT',
    name: 'Partitioning'
  },
  {
    code: 'PCE',
    name: 'Piece'
  },
  {
    code: 'PCS',
    name: 'Pieces'
  },
  {
    code: 'PIR',
    name: 'Pims'
  },
  {
    code: 'PLN',
    name: 'Pipeline'
  },
  {
    code: 'PRK',
    name: 'Pipe Rack'
  },
  {
    code: 'PLF',
    name: 'Platform'
  },
  {
    code: 'PLC',
    name: 'Primary Lift Container'
  },
  {
    code: 'POV',
    name: 'Private Vehicle'
  },
  {
    code: 'QTR',
    name: 'Quarter of Beef'
  },
  {
    code: 'RCK',
    name: 'Rack'
  },
  {
    code: 'RAL',
    name: 'Rail (Semiconductor)'
  },
  {
    code: 'REL',
    name: 'Reel'
  },
  {
    code: 'RFT',
    name: 'Reinforcement'
  },
  {
    code: 'RVR',
    name: 'Reverse Reel'
  },
  {
    code: 'ROL',
    name: 'Roll'
  },
  {
    code: 'SAK',
    name: 'Sack'
  },
  {
    code: 'SVN',
    name: 'Sea Van'
  },
  {
    code: 'SPR',
    name: 'Separator/Divider'
  },
  {
    code: 'SHT',
    name: 'Sheet'
  },
  {
    code: 'SHK',
    name: 'Shook'
  },
  {
    code: 'SHW',
    name: 'Shrink Wrapped'
  },
  {
    code: 'SID',
    name: 'Side of Beef'
  },
  {
    code: 'SKD',
    name: 'Skid'
  },
  {
    code: 'SKE',
    name: 'Skid, elevating or lift truck'
  },
  {
    code: 'SLV',
    name: 'Sleeve'
  },
  {
    code: 'SLP',
    name: 'Slip Sheet'
  },
  {
    code: 'SPI',
    name: 'Spin Cylinders'
  },
  {
    code: 'SPL',
    name: 'Spool'
  },
  {
    code: 'SCS',
    name: 'Suitcase'
  },
  {
    code: 'TNK',
    name: 'Tank'
  },
  {
    code: 'TKR',
    name: 'Tank Car'
  },
  {
    code: 'TKT',
    name: 'Tank Truck'
  },
  {
    code: 'TRC',
    name: 'Tierce'
  },
  {
    code: 'TBN',
    name: 'Tote Bin'
  },
  {
    code: 'TTC',
    name: 'Tote Can'
  },
  {
    code: 'TRY',
    name: 'Tray'
  },
  {
    code: 'TRI',
    name: 'Triwall Box'
  },
  {
    code: 'TRU',
    name: 'Truck'
  },
  {
    code: 'TRK',
    name: 'Trunk and Chest'
  },
  {
    code: 'TSS',
    name: 'Trunk, Salesmen Sample'
  },
  {
    code: 'TUB',
    name: 'Tub'
  },
  {
    code: 'TBE',
    name: 'Tube'
  },
  {
    code: 'UNT',
    name: 'Unit'
  },
  {
    code: 'UNP',
    name: 'Unpacked'
  },
  {
    code: 'VPK',
    name: 'Van Pack'
  },
  {
    code: 'VEH',
    name: 'Vehicles'
  },
  {
    code: 'WLC',
    name: 'Wheeled Carrier'
  },
  {
    code: 'WRP',
    name: 'Wrapped'
  }
];

export const acePackagingUnitsRaw = [
  {
    code: 'BAG',
    name: 'Bag'
  },
  {
    code: 'BLE',
    name: 'Bale'
  },
  {
    code: 'BBL',
    name: 'Barrel'
  },
  {
    code: 'BSK',
    name: 'Basket'
  },
  {
    code: 'BIN',
    name: 'Bin'
  },
  {
    code: 'BIC',
    name: 'Bing Chest'
  },
  {
    code: 'BOX',
    name: 'Box'
  },
  {
    code: 'BKT',
    name: 'Bucket'
  },
  {
    code: 'BDL',
    name: 'Bundle'
  },
  {
    code: 'CAN',
    name: 'Can'
  },
  {
    code: 'CCS',
    name: 'Can Case'
  },
  {
    code: 'CBY',
    name: 'Carboy'
  },
  {
    code: 'CAR',
    name: 'Carcass'
  },
  {
    code: 'CTN',
    name: 'Carton'
  },
  {
    code: 'CAS',
    name: 'Case'
  },
  {
    code: 'CSK',
    name: 'Cask'
  },
  {
    code: 'CHS',
    name: 'Chest'
  },
  {
    code: 'COL',
    name: 'Coil'
  },
  {
    code: 'CBC',
    name: 'Container Bulk Cargo'
  },
  {
    code: 'COR',
    name: 'Cord'
  },
  {
    code: 'CRT',
    name: 'Crate'
  },
  {
    code: 'CYL',
    name: 'Cylinder'
  },
  {
    code: 'DRM',
    name: 'Drum'
  },
  {
    code: 'DBK',
    name: 'Dry Bulk'
  },
  {
    code: 'GAL',
    name: 'Gallon'
  },
  {
    code: 'HMP',
    name: 'Hamper'
  },
  {
    code: 'HED',
    name: 'Heads of Beef'
  },
  {
    code: 'KEG',
    name: 'Keg'
  },
  {
    code: 'LVN',
    name: 'Lift Van'
  },
  {
    code: 'LBK',
    name: 'Liquid Bulk'
  },
  {
    code: 'LOG',
    name: 'Logs'
  },
  {
    code: 'LUG',
    name: 'Lugs'
  },
  {
    code: 'PKG',
    name: 'Package'
  },
  {
    code: 'PAL',
    name: 'Pail'
  },
  {
    code: 'PLT',
    name: 'Pallet'
  },
  {
    code: 'PCL',
    name: 'Parcel'
  },
  {
    code: 'PCS',
    name: 'Pieces'
  },
  {
    code: 'POV',
    name: 'Private Vehicle'
  },
  {
    code: 'QTR',
    name: 'Quarters of Beef'
  },
  {
    code: 'REL',
    name: 'Reel'
  },
  {
    code: 'ROL',
    name: 'Roll'
  },
  {
    code: 'SAK',
    name: 'Sack'
  },
  {
    code: 'SHT',
    name: 'Sheet'
  },
  {
    code: 'SID',
    name: 'Sides of Beef'
  },
  {
    code: 'SKD',
    name: 'Skid'
  },
  {
    code: 'TNK',
    name: 'Tank'
  },
  {
    code: 'TIN',
    name: 'Tin'
  },
  {
    code: 'TBN',
    name: 'Tote Bin'
  },
  {
    code: 'TBE',
    name: 'Tube'
  },
  {
    code: 'UNT',
    name: 'Unit'
  },
  {
    code: 'VPK',
    name: 'Van Pack'
  },
  {
    code: 'VEH',
    name: 'Vehicle'
  },
  {
    code: 'WDC',
    name: 'Wooden Case'
  }
];

export const countriesRaw = [
  {
    name: 'Afghanistan',
    code: 'AF'
  },
  {
    name: 'Albania',
    code: 'AL'
  },
  {
    name: 'Algeria',
    code: 'DZ'
  },
  {
    name: 'American Samoa',
    code: 'AS'
  },
  {
    name: 'Andorra',
    code: 'AD'
  },
  {
    name: 'Angola',
    code: 'AO'
  },
  {
    name: 'Anguilla',
    code: 'AI'
  },
  {
    name: 'Antigua and Barbuda',
    code: 'AG'
  },
  {
    name: 'Argentina',
    code: 'AR'
  },
  {
    name: 'Armenia',
    code: 'AM'
  },
  {
    name: 'Aruba',
    code: 'AW'
  },
  {
    name: 'Australia',
    code: 'AU'
  },
  {
    name: 'Austria',
    code: 'AT'
  },
  {
    name: 'Azerbaijan',
    code: 'AZ'
  },
  {
    name: 'Bahamas',
    code: 'BS'
  },
  {
    name: 'Bahrain',
    code: 'BH'
  },
  {
    name: 'Bangladesh',
    code: 'BD'
  },
  {
    name: 'Barbados',
    code: 'BB'
  },
  {
    name: 'Belarus',
    code: 'BY'
  },
  {
    name: 'Belgium',
    code: 'BE'
  },
  {
    name: 'Belize',
    code: 'BZ'
  },
  {
    name: 'Benin',
    code: 'BJ'
  },
  {
    name: 'Bermuda',
    code: 'BM'
  },
  {
    name: 'Bhutan',
    code: 'BT'
  },
  {
    name: 'Bolivia',
    code: 'BO'
  },
  {
    name: 'Bosnia-Hercegovina',
    code: 'BA'
  },
  {
    name: 'Botswana',
    code: 'BW'
  },
  {
    name: 'Brazil',
    code: 'BR'
  },
  {
    name: 'British Indian Ocean Territory',
    code: 'IO'
  },
  {
    name: 'Brunei Darussalam',
    code: 'BN'
  },
  {
    name: 'Bulgaria',
    code: 'BG'
  },
  {
    name: 'Burkina Faso',
    code: 'BF'
  },
  {
    name: 'Burma (Myanmar)',
    code: 'MM'
  },
  {
    name: 'Burundi',
    code: 'BI'
  },
  {
    name: 'Cambodia',
    code: 'KH'
  },
  {
    name: 'Cameroon',
    code: 'CM'
  },
  {
    name: 'Canada',
    code: 'CA'
  },
  {
    name: 'Cape Verde',
    code: 'CV'
  },
  {
    name: 'Cayman Islands',
    code: 'KY'
  },
  {
    name: 'Central African Republic',
    code: 'CF'
  },
  {
    name: 'Chad',
    code: 'TD'
  },
  {
    name: 'Chile',
    code: 'CL'
  },
  {
    name: 'China',
    code: 'CN'
  },
  {
    name: 'Christmas Island',
    code: 'CX'
  },
  {
    name: 'Cocos (Keeling) Island',
    code: 'CC'
  },
  {
    name: 'Colombia',
    code: 'CO'
  },
  {
    name: 'Comoros',
    code: 'KM'
  },
  {
    name: 'Congo (Brazzaville)',
    code: 'CG'
  },
  {
    name: 'Cook Islands',
    code: 'CK'
  },
  {
    name: 'Costa Rica',
    code: 'CR'
  },
  {
    name: 'Croatia',
    code: 'HR'
  },
  {
    name: 'Cuba',
    code: 'CU'
  },
  {
    name: 'Curacao',
    code: 'CW'
  },
  {
    name: 'Cyprus',
    code: 'CY'
  },
  {
    name: 'Czech Republic, The',
    code: 'CZ'
  },
  {
    name: 'Denmark',
    code: 'DK'
  },
  {
    name: 'Djibouti',
    code: 'DJ'
  },
  {
    name: 'Dominica',
    code: 'DM'
  },
  {
    name: 'Dominican Republic',
    code: 'DO'
  },
  {
    name: 'East Timor',
    code: 'TP'
  },
  {
    name: 'Ecuador',
    code: 'EC'
  },
  {
    name: 'Egypt',
    code: 'EG'
  },
  {
    name: 'El Salvador',
    code: 'SV'
  },
  {
    name: 'Equatorial Guinea',
    code: 'GQ'
  },
  {
    name: 'Eritrea',
    code: 'ER'
  },
  {
    name: 'Estonia',
    code: 'EE'
  },
  {
    name: 'Ethiopia',
    code: 'ET'
  },
  {
    name: 'Falkland Islands (Malvinas)',
    code: 'FK'
  },
  {
    name: 'Faroe Islands',
    code: 'FO'
  },
  {
    name: 'Fiji',
    code: 'FJ'
  },
  {
    name: 'Finland',
    code: 'FI'
  },
  {
    name: 'France',
    code: 'FR'
  },
  {
    name: 'French Guiana',
    code: 'GF'
  },
  {
    name: 'French Polynesia',
    code: 'PF'
  },
  {
    name: 'French Southern Territories',
    code: 'TF'
  },
  {
    name: 'Gabon',
    code: 'GA'
  },
  {
    name: 'Gambia',
    code: 'GM'
  },
  {
    name: 'Gaza Strip Administered by Israel',
    code: 'GZ'
  },
  {
    name: 'Georgia',
    code: 'GE'
  },
  {
    name: 'Germany, (Federal Republic of Germany)',
    code: 'DE'
  },
  {
    name: 'Ghana',
    code: 'GH'
  },
  {
    name: 'Gibraltar',
    code: 'GI'
  },
  {
    name: 'Greece',
    code: 'GR'
  },
  {
    name: 'Greenland',
    code: 'GL'
  },
  {
    name: 'Grenada',
    code: 'GD'
  },
  {
    name: 'Guadeloupe',
    code: 'GP'
  },
  {
    name: 'Guam',
    code: 'GU'
  },
  {
    name: 'Guatemala',
    code: 'GT'
  },
  {
    name: 'Guinea',
    code: 'GN'
  },
  {
    name: 'Guinea-Bissau',
    code: 'GW'
  },
  {
    name: 'Guyana',
    code: 'GY'
  },
  {
    name: 'Haiti',
    code: 'HT'
  },
  {
    name: 'Heard and McDonald Islands',
    code: 'HM'
  },
  {
    name: 'Honduras',
    code: 'HN'
  },
  {
    name: 'Hong Kong',
    code: 'HK'
  },
  {
    name: 'Hungary',
    code: 'HU'
  },
  {
    name: 'Iceland',
    code: 'IS'
  },
  {
    name: 'India',
    code: 'IN'
  },
  {
    name: 'Indonesia',
    code: 'ID'
  },
  {
    name: 'Iran, Islamic Republic of',
    code: 'IR'
  },
  {
    name: 'Iraq',
    code: 'IQ'
  },
  {
    name: 'Ireland',
    code: 'IE'
  },
  {
    name: 'Israel',
    code: 'IL'
  },
  {
    name: 'Italy',
    code: 'IT'
  },
  {
    name: "Ivory Coast (Cote D'ivoire)",
    code: 'CI'
  },
  {
    name: 'Jamaica',
    code: 'JM'
  },
  {
    name: 'Japan',
    code: 'JP'
  },
  {
    name: 'Jordan',
    code: 'JO'
  },
  {
    name: 'Kazakhstan',
    code: 'KZ'
  },
  {
    name: 'Kenya',
    code: 'KE'
  },
  {
    name: 'Kiribati',
    code: 'KI'
  },
  {
    name: "Korea, Democratic People's Republic of (North Korea)",
    code: 'KP'
  },
  {
    name: 'Korea, Republic of (South Korea)',
    code: 'KR'
  },
  {
    name: 'Kosovo',
    code: 'KV'
  },
  {
    name: 'Kuwait',
    code: 'KW'
  },
  {
    name: 'Kyrgyzstan',
    code: 'KG'
  },
  {
    name: "Lao People's Democratic Republic",
    code: 'LA'
  },
  {
    name: 'Latvia',
    code: 'LV'
  },
  {
    name: 'Lebanon',
    code: 'LB'
  },
  {
    name: 'Lesotho',
    code: 'LS'
  },
  {
    name: 'Liberia',
    code: 'LR'
  },
  {
    name: 'Libya (Libyan Arab Jamahiriya)',
    code: 'LY'
  },
  {
    name: 'Liechtenstein',
    code: 'LI'
  },
  {
    name: 'Lithuania',
    code: 'LT'
  },
  {
    name: 'Luxembourg',
    code: 'LU'
  },
  {
    name: 'Macau',
    code: 'MO'
  },
  {
    name: 'Macedonia, The Former Yugoslav Republic of (Skopje)',
    code: 'MK'
  },
  {
    name: 'Madagascar',
    code: 'MG'
  },
  {
    name: 'Malawi',
    code: 'MW'
  },
  {
    name: 'Malaysia',
    code: 'MY'
  },
  {
    name: 'Maldives',
    code: 'MV'
  },
  {
    name: 'Mali',
    code: 'ML'
  },
  {
    name: 'Malta',
    code: 'MT'
  },
  {
    name: 'Marshall Islands',
    code: 'MH'
  },
  {
    name: 'Martinique',
    code: 'MQ'
  },
  {
    name: 'Mauritania',
    code: 'MR'
  },
  {
    name: 'Mauritius',
    code: 'MU'
  },
  {
    name: 'Mayotte',
    code: 'YT'
  },
  {
    name: 'Mexico',
    code: 'MX'
  },
  {
    name: 'Micronesia, Federated States of',
    code: 'FM'
  },
  {
    name: 'Moldova, Republic of',
    code: 'MD'
  },
  {
    name: 'Monaco',
    code: 'MC'
  },
  {
    name: 'Mongolia',
    code: 'MN'
  },
  {
    name: 'Montenegro',
    code: 'ME'
  },
  {
    name: 'Montserrat',
    code: 'MS'
  },
  {
    name: 'Morocco',
    code: 'MA'
  },
  {
    name: 'Mozambique',
    code: 'MZ'
  },
  {
    name: 'Namibia',
    code: 'NA'
  },
  {
    name: 'Nauru',
    code: 'NR'
  },
  {
    name: 'Nepal',
    code: 'NP'
  },
  {
    name: 'Netherlands',
    code: 'NL'
  },
  {
    name: 'Netherlands Antilles',
    code: 'AN'
  },
  {
    name: 'New Caledonia',
    code: 'NC'
  },
  {
    name: 'New Zealand',
    code: 'NZ'
  },
  {
    name: 'Nicaragua',
    code: 'NI'
  },
  {
    name: 'Niger',
    code: 'NE'
  },
  {
    name: 'Nigeria',
    code: 'NG'
  },
  {
    name: 'Niue',
    code: 'NU'
  },
  {
    name: 'Norfolk Island',
    code: 'NF'
  },
  {
    name: 'Northern Mariana Islands',
    code: 'MP'
  },
  {
    name: 'Norway',
    code: 'NO'
  },
  {
    name: 'Oman',
    code: 'OM'
  },
  {
    name: 'Pakistan',
    code: 'PK'
  },
  {
    name: 'Palau',
    code: 'PW'
  },
  {
    name: 'Palestine',
    code: 'PS'
  },
  {
    name: 'Panama',
    code: 'PA'
  },
  {
    name: 'Papua New Guinea',
    code: 'PG'
  },
  {
    name: 'Paraguay',
    code: 'PY'
  },
  {
    name: 'Peru',
    code: 'PE'
  },
  {
    name: 'Philippines',
    code: 'PH'
  },
  {
    name: 'Pitcairn',
    code: 'PN'
  },
  {
    name: 'Poland',
    code: 'PL'
  },
  {
    name: 'Portugal',
    code: 'PT'
  },
  {
    name: 'Puerto Rico',
    code: 'PR'
  },
  {
    name: 'Qatar',
    code: 'QA'
  },
  {
    name: 'Reunion',
    code: 'RE'
  },
  {
    name: 'Romania',
    code: 'RO'
  },
  {
    name: 'Russia (Russian Federation)',
    code: 'RU'
  },
  {
    name: 'Rwanda',
    code: 'RW'
  },
  {
    name: 'Saint Vincent and the Grenadines',
    code: 'VC'
  },
  {
    name: 'San Marino',
    code: 'SM'
  },
  {
    name: 'Sao Tome and Principe',
    code: 'ST'
  },
  {
    name: 'Saudi Arabia',
    code: 'SA'
  },
  {
    name: 'Senegal',
    code: 'SN'
  },
  {
    name: 'Serbia',
    code: 'RS'
  },
  {
    name: 'Seychelles',
    code: 'SC'
  },
  {
    name: 'Sierra Leone',
    code: 'SL'
  },
  {
    name: 'Singapore',
    code: 'SG'
  },
  {
    name: 'Slovakia',
    code: 'SK'
  },
  {
    name: 'Slovenia',
    code: 'SI'
  },
  {
    name: 'Solomon Islands',
    code: 'SB'
  },
  {
    name: 'Somalia',
    code: 'SO'
  },
  {
    name: 'South Africa',
    code: 'ZA'
  },
  {
    name: 'Spain',
    code: 'ES'
  },
  {
    name: 'Sri Lanka',
    code: 'LK'
  },
  {
    name: 'St. Helena',
    code: 'SH'
  },
  {
    name: 'St. Kitts and Nevis',
    code: 'KN'
  },
  {
    name: 'St. Lucia',
    code: 'LC'
  },
  {
    name: 'St. Pierre and Miquelon',
    code: 'PM'
  },
  {
    name: 'Sudan',
    code: 'SD'
  },
  {
    name: 'Suriname',
    code: 'SR'
  },
  {
    name: 'Svalbard and Jan Mayen',
    code: 'SJ'
  },
  {
    name: 'Swaziland',
    code: 'SZ'
  },
  {
    name: 'Sweden',
    code: 'SE'
  },
  {
    name: 'Switzerland',
    code: 'CH'
  },
  {
    name: 'Syria (Syrian Arab Republic)',
    code: 'SY'
  },
  {
    name: 'Taiwan',
    code: 'TW'
  },
  {
    name: 'Tajikistan',
    code: 'TJ'
  },
  {
    name: 'Tanzania, United Republic of',
    code: 'TZ'
  },
  {
    name: 'Thailand',
    code: 'TH'
  },
  {
    name: 'Togo',
    code: 'TG'
  },
  {
    name: 'Tokelau',
    code: 'TK'
  },
  {
    name: 'Tonga',
    code: 'TO'
  },
  {
    name: 'Trinidad and Tobago',
    code: 'TT'
  },
  {
    name: 'Tunisia',
    code: 'TN'
  },
  {
    name: 'Turkey',
    code: 'TR'
  },
  {
    name: 'Turkmenistan',
    code: 'TM'
  },
  {
    name: 'Turks and Caicos Islands',
    code: 'TC'
  },
  {
    name: 'Tuvalu',
    code: 'TV'
  },
  {
    name: 'Uganda',
    code: 'UG'
  },
  {
    name: 'Ukraine',
    code: 'UA'
  },
  {
    name: 'United Arab Emirates',
    code: 'AE'
  },
  {
    name: 'United Kingdom',
    code: 'GB'
  },
  {
    name: 'United States',
    code: 'US'
  },
  {
    name: 'Uruguay',
    code: 'UY'
  },
  {
    name: 'US minor outlying Islands',
    code: 'UM'
  },
  {
    name: 'Uzbekistan',
    code: 'UZ'
  },
  {
    name: 'Vanuatu',
    code: 'VU'
  },
  {
    name: 'Vatican City (Holy See)',
    code: 'VA'
  },
  {
    name: 'Venezuela',
    code: 'VE'
  },
  {
    name: 'Vietnam',
    code: 'VN'
  },
  {
    name: 'Virgin Islands, British',
    code: 'VG'
  },
  {
    name: 'Virgin Islands of the United States',
    code: 'VI'
  },
  {
    name: 'Wallis and Futuna',
    code: 'WF'
  },
  {
    name: 'West Bank Administered by Israel',
    code: 'WE'
  },
  {
    name: 'Western Sahara',
    code: 'EH'
  },
  {
    name: 'Western Samoa',
    code: 'WS'
  },
  {
    name: 'Yemen',
    code: 'YE'
  },
  {
    name: 'Yugoslavia',
    code: 'YU'
  },
  {
    name: 'Zaire (Congo, Democratic Republic of the)',
    code: 'CD'
  },
  {
    name: 'Zambia',
    code: 'ZM'
  },
  {
    name: 'Zimbabwe',
    code: 'ZW'
  }
];

export const stateProvinceRaw = [
  {
    code: 'AB',
    name: 'Alberta',
    country: 'CA'
  },
  {
    code: 'BC',
    name: 'British Columbia',
    country: 'CA'
  },
  {
    code: 'MB',
    name: 'Manitoba',
    country: 'CA'
  },
  {
    code: 'NB',
    name: 'New Brunswick',
    country: 'CA'
  },
  {
    code: 'NL',
    name: 'New Foundland and Labrador',
    country: 'CA'
  },
  {
    code: 'NT',
    name: 'Northwest Territories',
    country: 'CA'
  },
  {
    code: 'NS',
    name: 'Nova Scotia',
    country: 'CA'
  },
  {
    code: 'NU',
    name: 'Nunavut',
    country: 'CA'
  },
  {
    code: 'ON',
    name: 'Ontario',
    country: 'CA'
  },
  {
    code: 'PE',
    name: 'Prince Edward Island',
    country: 'CA'
  },
  {
    code: 'QC',
    name: 'Quebec',
    country: 'CA'
  },
  {
    code: 'SK',
    name: 'Saskatchewan',
    country: 'CA'
  },
  {
    code: 'YT',
    name: 'Yukon Territory',
    country: 'CA'
  },
  {
    code: 'AGU',
    name: 'Aguascalientes',
    country: 'MX'
  },
  {
    code: 'AL',
    name: 'Alabama',
    country: 'US'
  },
  {
    code: 'AK',
    name: 'Alaska',
    country: 'US'
  },
  {
    code: 'AS',
    name: 'American Samoa',
    country: 'US'
  },
  {
    code: 'AZ',
    name: 'Arizona',
    country: 'US'
  },
  {
    code: 'AR',
    name: 'Arkansas',
    country: 'US'
  },
  {
    code: 'AA',
    name: 'Armed Forces America',
    country: 'US'
  },
  {
    code: 'AE',
    name: 'Armed Forces Europe',
    country: 'US'
  },
  {
    code: 'AP',
    name: 'Armed Forces Pacific',
    country: 'US'
  },
  {
    code: 'BCN',
    name: 'Baja California Nord',
    country: 'MX'
  },
  {
    code: 'BCS',
    name: 'Baja California Sur',
    country: 'MX'
  },
  {
    code: 'CA',
    name: 'California',
    country: 'US'
  },
  {
    code: 'CAM',
    name: 'Campeche',
    country: 'MX'
  },
  {
    code: 'CHP',
    name: 'Chiapas',
    country: 'MX'
  },
  {
    code: 'CHH',
    name: 'Chihuahua',
    country: 'MX'
  },
  {
    code: 'COA',
    name: 'Coahuila',
    country: 'MX'
  },
  {
    code: 'COL',
    name: 'Colima',
    country: 'MX'
  },
  {
    code: 'CO',
    name: 'Colorado',
    country: 'US'
  },
  {
    code: 'CT',
    name: 'Connecticut',
    country: 'US'
  },
  {
    code: 'DE',
    name: 'Delaware',
    country: 'US'
  },
  {
    code: 'DC',
    name: 'District of Columbia',
    country: 'US'
  },
  {
    code: 'DIF',
    name: 'Distrito Federal',
    country: 'MX'
  },
  {
    code: 'DUR',
    name: 'Durango',
    country: 'MX'
  },
  {
    code: 'FL',
    name: 'Florida',
    country: 'US'
  },
  {
    code: 'GA',
    name: 'Georgia',
    country: 'US'
  },
  {
    code: 'GU',
    name: 'Guam',
    country: 'US'
  },
  {
    code: 'GUA',
    name: 'Guanajuato',
    country: 'MX'
  },
  {
    code: 'GRO',
    name: 'Guerrero',
    country: 'MX'
  },
  {
    code: 'HI',
    name: 'Hawaii',
    country: 'US'
  },
  {
    code: 'HID',
    name: 'Hidalgo',
    country: 'MX'
  },
  {
    code: 'ID',
    name: 'Idaho',
    country: 'US'
  },
  {
    code: 'IL',
    name: 'Illinois',
    country: 'US'
  },
  {
    code: 'IN',
    name: 'Indiana',
    country: 'US'
  },
  {
    code: 'IA',
    name: 'Iowa',
    country: 'US'
  },
  {
    code: 'JAL',
    name: 'Jalisco',
    country: 'MX'
  },
  {
    code: 'KS',
    name: 'Kansas',
    country: 'US'
  },
  {
    code: 'KY',
    name: 'Kentucky',
    country: 'US'
  },
  {
    code: 'LA',
    name: 'Louisiana',
    country: 'US'
  },
  {
    code: 'ME',
    name: 'Maine',
    country: 'US'
  },
  {
    code: 'MD',
    name: 'Maryland',
    country: 'US'
  },
  {
    code: 'MA',
    name: 'Massachusetts',
    country: 'US'
  },
  {
    code: 'MEX',
    name: 'Mexico State',
    country: 'MX'
  },
  {
    code: 'MI',
    name: 'Michigan',
    country: 'US'
  },
  {
    code: 'MIC',
    name: 'Michoacan',
    country: 'MX'
  },
  {
    code: 'MN',
    name: 'Minnesota',
    country: 'US'
  },
  {
    code: 'MS',
    name: 'Mississippi',
    country: 'US'
  },
  {
    code: 'MO',
    name: 'Missouri',
    country: 'US'
  },
  {
    code: 'MT',
    name: 'Montana',
    country: 'US'
  },
  {
    code: 'MOR',
    name: 'Morelos',
    country: 'MX'
  },
  {
    code: 'NAY',
    name: 'Nayarit',
    country: 'MX'
  },
  {
    code: 'NE',
    name: 'Nebraska',
    country: 'US'
  },
  {
    code: 'NV',
    name: 'Nevada',
    country: 'US'
  },
  {
    code: 'NH',
    name: 'New Hampshire',
    country: 'US'
  },
  {
    code: 'NJ',
    name: 'New Jersey',
    country: 'US'
  },
  {
    code: 'NM',
    name: 'New Mexico',
    country: 'US'
  },
  {
    code: 'NY',
    name: 'New York',
    country: 'US'
  },
  {
    code: 'NP',
    name: 'No Plate',
    country: 'US'
  },
  {
    code: 'NC',
    name: 'North Carolina',
    country: 'US'
  },
  {
    code: 'ND',
    name: 'North Dakota',
    country: 'US'
  },
  {
    code: 'MP',
    name: 'Northern Mariana Island',
    country: 'US'
  },
  {
    code: 'NLE',
    name: 'Nuevo Leon',
    country: 'MX'
  },
  {
    code: 'OAX',
    name: 'Oaxaca',
    country: 'MX'
  },
  {
    code: 'OH',
    name: 'Ohio',
    country: 'US'
  },
  {
    code: 'OK',
    name: 'Oklahoma',
    country: 'US'
  },
  {
    code: 'OR',
    name: 'Oregon',
    country: 'US'
  },
  {
    code: 'PA',
    name: 'Pennsylvania',
    country: 'US'
  },
  {
    code: 'PUE',
    name: 'Puebla',
    country: 'MX'
  },
  {
    code: 'PR',
    name: 'Puerto Rico',
    country: 'US'
  },
  {
    code: 'QUE',
    name: 'Queretaro',
    country: 'MX'
  },
  {
    code: 'ROO',
    name: 'Quintana Roo',
    country: 'MX'
  },
  {
    code: 'RI',
    name: 'Rhode Island',
    country: 'US'
  },
  {
    code: 'SLP',
    name: 'San Luis Potosi',
    country: 'MX'
  },
  {
    code: 'SIN',
    name: 'Sinaloa',
    country: 'MX'
  },
  {
    code: 'SON',
    name: 'Sonora',
    country: 'MX'
  },
  {
    code: 'SC',
    name: 'South Carolina',
    country: 'US'
  },
  {
    code: 'SD',
    name: 'South Dakota',
    country: 'US'
  },
  {
    code: 'TAB',
    name: 'Tabasco',
    country: 'MX'
  },
  {
    code: 'TAM',
    name: 'Tamaulipas',
    country: 'MX'
  },
  {
    code: 'TN',
    name: 'Tennessee',
    country: 'US'
  },
  {
    code: 'TX',
    name: 'Texas',
    country: 'US'
  },
  {
    code: 'TLA',
    name: 'Tlaxcala',
    country: 'MX'
  },
  {
    code: 'UT',
    name: 'Utah',
    country: 'US'
  },
  {
    code: 'VER',
    name: 'Vera Cruz',
    country: 'MX'
  },
  {
    code: 'VT',
    name: 'Vermont',
    country: 'US'
  },
  {
    code: 'VA',
    name: 'Virginia',
    country: 'US'
  },
  {
    code: 'VI',
    name: 'Virgin Islands',
    country: 'US'
  },
  {
    code: 'WA',
    name: 'Washington',
    country: 'US'
  },
  {
    code: 'WV',
    name: 'West Virginia',
    country: 'US'
  },
  {
    code: 'WI',
    name: 'Wisconsin',
    country: 'US'
  },
  {
    code: 'WY',
    name: 'Wyoming',
    country: 'US'
  },
  {
    code: 'YUC',
    name: 'Yucatan',
    country: 'MX'
  },
  {
    code: 'ZAC',
    name: 'Zacatecas',
    country: 'MX'
  }
];

export const travelDocsRaw = [
  {
    code: 'BCN',
    description: 'Birth Certificate',
    stateProvinceRequired: false,
    countryRequired: true
  },
  {
    code: 'CON',
    description: 'Certificate of Naturalization',
    stateProvinceRequired: false,
    countryRequired: true
  },
  {
    code: 'CDN',
    description: 'Citizenship Document Number  (Citizenship Card)',
    stateProvinceRequired: false,
    countryRequired: true
  },
  {
    code: '5K',
    description: "Commercial Driver's License",
    stateProvinceRequired: true,
    countryRequired: false
  },
  {
    code: 'HD',
    description: 'DOT Hazardous Number',
    stateProvinceRequired: true,
    countryRequired: false
  },
  {
    code: '5J',
    description: "Driver's License",
    stateProvinceRequired: true,
    countryRequired: false
  },
  {
    code: '6W',
    description: 'Enhanced Drivers License',
    stateProvinceRequired: true,
    countryRequired: false
  },
  {
    code: 'BCP',
    description: 'Laser Visa Border Crossing Card',
    stateProvinceRequired: false,
    countryRequired: true
  },
  {
    code: 'AAG',
    description: 'Military ID Document',
    stateProvinceRequired: false,
    countryRequired: true
  },
  {
    code: 'ALY',
    description: 'Native American Indian/INAC',
    stateProvinceRequired: false,
    countryRequired: true
  },
  {
    code: 'AEW',
    description: 'NEXUS Card',
    stateProvinceRequired: false,
    countryRequired: true
  },
  {
    code: 'OTD',
    description: 'Other Travel Document ID',
    stateProvinceRequired: false,
    countryRequired: true
  },
  {
    code: 'ACW',
    description: 'Passport',
    stateProvinceRequired: false,
    countryRequired: true
  },
  {
    code: 'AGS',
    description: 'Permanent Resident Card C1 - US Resident',
    stateProvinceRequired: false,
    countryRequired: true
  },
  {
    code: 'ACU',
    description: 'Permanent Resident Card C2 - Resident Commuter',
    stateProvinceRequired: false,
    countryRequired: false
  },
  {
    code: 'REP',
    description: 'Reentry Permit',
    stateProvinceRequired: false,
    countryRequired: false
  },
  {
    code: 'RTP',
    description: 'Refugee Travel Permit',
    stateProvinceRequired: false,
    countryRequired: false
  },
  {
    code: 'ALV',
    description: 'SENTRI Card',
    stateProvinceRequired: false,
    countryRequired: true
  },
  {
    code: 'AGR',
    description: 'US Alien Registration Card A1',
    stateProvinceRequired: false,
    countryRequired: false
  },
  {
    code: 'ALR',
    description: 'US Alien Registration Card A2',
    stateProvinceRequired: false,
    countryRequired: true
  },
  {
    code: 'ALX',
    description: 'US Merchant Mariner Document ID',
    stateProvinceRequired: false,
    countryRequired: true
  },
  {
    code: 'AEF',
    description: 'US Passport Card',
    stateProvinceRequired: false,
    countryRequired: true
  },
  {
    code: '30',
    description: 'Visa - Immigrant',
    stateProvinceRequired: false,
    countryRequired: false
  },
  {
    code: 'AGT',
    description: 'Visa Non-Immigrant',
    stateProvinceRequired: false,
    countryRequired: true
  }
];

export const truckTypesRaw = [
  {
    code: 'TR',
    name: 'Tractor (Semi)'
  },
  {
    code: 'AR',
    name: 'Armored truck'
  },
  {
    code: 'AU',
    name: 'Automobile'
  },
  {
    code: 'BT',
    name: 'Box truck'
  },
  {
    code: 'BU',
    name: 'Bus'
  },
  {
    code: 'BV',
    name: 'Beverage truck'
  },
  {
    code: 'BY',
    name: 'Bicycle'
  },
  {
    code: 'CO',
    name: 'Construction vehicle (General)'
  },
  {
    code: 'EV',
    name: 'Emergency vehicle (General)'
  },
  {
    code: 'FE',
    name: 'Ferry'
  },
  {
    code: 'FM',
    name: 'Farm tractor'
  },
  {
    code: 'GB',
    name: 'Garbage truck'
  },
  {
    code: 'MC',
    name: 'Motorcycle'
  },
  {
    code: 'OC',
    name: 'Other'
  },
  {
    code: 'PM',
    name: 'Pick-up truck with camper'
  },
  {
    code: 'PN',
    name: 'Panel truck'
  },
  {
    code: 'PU',
    name: 'Pick-up truck'
  },
  {
    code: 'PV',
    name: 'Passenger, van'
  },
  {
    code: 'RV',
    name: 'Recreation vehicle'
  },
  {
    code: 'TV',
    name: 'Van'
  }
];

export const trailerTypesRaw = [
  {
    code: 'TF',
    description: 'Trailer (Dry freight)'
  },
  {
    code: '2B',
    description: '20 ft. Container (Closed top) sea container'
  },
  {
    code: '20',
    description: '20 ft. Container (Open top) sea container'
  },
  {
    code: '4B',
    description: '40 ft. Container (Closed top) sea container'
  },
  {
    code: '40',
    description: '40 ft. Container (Open top) sea container'
  },
  {
    code: 'TC',
    description: 'Auto carrier/trailer'
  },
  {
    code: 'BI',
    description: 'Beverage rack trailer'
  },
  {
    code: 'CH',
    description: 'Chassis'
  },
  {
    code: 'RT',
    description: 'Controlled temperature'
  },
  {
    code: 'TW',
    description: 'Controlled temperature trailer'
  },
  {
    code: 'DD',
    description: 'Double drop trailer'
  },
  {
    code: 'DT',
    description: 'Drop back trailer'
  },
  {
    code: 'RD',
    description: 'Fixed rack, Double drop trailer'
  },
  {
    code: 'RS',
    description: 'Fixed rack, Single drop trailer'
  },
  {
    code: 'FT',
    description: 'Flatbed/Perform trailer'
  },
  {
    code: 'FR',
    description: 'Flatbed trailer'
  },
  {
    code: 'FH',
    description: 'Flatbed trailer with headboards'
  },
  {
    code: 'FN',
    description: 'Flatbed trailer with no headboards'
  },
  {
    code: 'RG',
    description: 'Gondola (Closed)'
  },
  {
    code: 'RO',
    description: 'Gondola (Open)'
  },
  {
    code: 'CB',
    description: 'Gooseneck trailer'
  },
  {
    code: 'HC',
    description: 'Hopper car (Covered)'
  },
  {
    code: 'HP',
    description: 'Hopper car  (Covered; Pneumatic discharge)'
  },
  {
    code: 'HO',
    description: 'Hopper car (Open)'
  },
  {
    code: 'HE',
    description: 'Horse trailer'
  },
  {
    code: 'LT',
    description: 'Livestock trailer'
  },
  {
    code: 'NC',
    description: 'No equipment'
  },
  {
    code: 'OE',
    description: 'Other'
  },
  {
    code: 'CL',
    description: 'Other length sea container (Closed top)'
  },
  {
    code: 'CU',
    description: 'Other length sea container (Open top)'
  },
  {
    code: 'CZ',
    description: 'Refrigerated container'
  },
  {
    code: 'TL',
    description: 'Semi truck trailer'
  },
  {
    code: 'SD',
    description: 'Single drop trailer'
  },
  {
    code: 'T8',
    description: 'Tank trailer (Chemicals) - Heated/Insulated'
  },
  {
    code: 'T6',
    description: 'Tank trailer (Chemicals) - Heated/Not insulated'
  },
  {
    code: 'T7',
    description: 'Tank trailer (Chemicals) - Not heated/Insulated'
  },
  {
    code: 'T5',
    description: 'Tank trailer (Chemicals) - Not heated/Not insulated'
  },
  {
    code: 'TK',
    description: 'Tank trailer (Food grade liquids)'
  },
  {
    code: 'T4',
    description: 'Tank trailer (Gas) - Heated/Insulated'
  },
  {
    code: 'T2',
    description: 'Tank trailer (Gas) - Heated/Not insulated'
  },
  {
    code: 'T3',
    description: 'Tank trailer (Gas) - Not heated/Insulated'
  },
  {
    code: 'T1',
    description: 'Tank trailer (Gas) - Not heated/Not insulated'
  },
  {
    code: 'L4',
    description: 'Tank trailer (Liquids) - Heated/Insulated'
  },
  {
    code: 'L2',
    description: 'Tank trailer (Liquids) - Heated/Not insulated'
  },
  {
    code: 'L3',
    description: 'Tank trailer (Liquids) - Not heated/Insulated'
  },
  {
    code: 'L1',
    description: 'Tank trailer (Liquids) - Not heated/Not insulated'
  }
];

export const aceShipmentTypesRaw = [
  {
    code: 'PAPS',
    description: 'PAPS'
  },
  {
    code: 'IN_BOND',
    description: 'Ace In-Bond'
  },
  {
    code: 'QP_IN_BOND',
    description: 'QP In-Bond'
  },
  {
    code: 'SECTION_321',
    description: 'Section 321'
  },
  {
    code: 'SECTION_321_FDA',
    description: 'Section 321 with FDA Considerations'
  },
  {
    code: 'GOODS_ASTRAY',
    description: 'Goods Astray'
  },
  {
    code: 'INTANGIBLES',
    description: 'Intangibles'
  },
  {
    code: 'ATTACHED_CF7523',
    description: 'Free of Duty (Customs Form 7523)'
  },
  {
    code: 'ATTACHED_CF3311',
    description: 'Returned American Products (Customs Form 3311)'
  },
  {
    code: 'ATTACHED_CF3299',
    description: 'Personal Shipment (Customs Form 3299)'
  }
];

export const aciShipmentTypesRaw = [
  {
    code: 'PARS',
    description: 'PARS'
  },
  {
    code: 'CSA',
    description: 'CSA'
  },
  {
    code: 'BOND',
    description: 'In-Bond'
  },
  {
    code: 'E29B',
    description: 'E29B Temporary Admission Permit'
  },
  {
    code: 'ATA',
    description: 'ATA Carnet'
  },
  {
    code: 'OIC',
    description: 'Orders In Council'
  },
  {
    code: 'PG',
    description: 'Personal Goods'
  },
  {
    code: 'A49',
    description: 'A49 Automotive Release'
  },
  {
    code: 'PAPER_RMD',
    description: 'Paper RMD'
  },
  {
    code: 'PAPER_B3',
    description: 'Paper B3'
  },
  {
    code: 'ASTRAY',
    description: 'Goods Astray'
  },
  {
    code: 'MILITARY',
    description: 'Military Goods consigned to Dept of National Defence'
  },
  {
    code: 'VI',
    description: 'Value Included'
  },
  {
    code: 'MP',
    description: 'Master Provisional'
  },
  {
    code: 'ALR',
    description: 'Automotive Line Release'
  }
];
